// MUTATIONS
export const SET_IS_MODAL_VISIBLE = 'setIsModalVisible';
export const SET_SELECTED_USER_GROUP = 'setSelectedUserGroup';
export const SET_IS_LOADING = 'isLoading';
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';

// ACTIONS
export const ACTION_GET_USERS_GROUPS = 'getUsersGroups';
export const ACTION_ADD_USER_GROUP = 'addUserGroup';
export const ACTION_UPDATE_USER_GROUP = 'updateUserGroup';
export const ACTION_REMOVE_USER_GROUP = 'removeUserGroup';
export const ACTION_SHOW_MODAL = 'showModal';
export const ACTION_HIDE_MODAL = 'hideModal';

// GETTERS
export const GET_SELECTED_USER_GROUP = 'selectedUserGroup';
export const GET_IS_LOADING = 'isLoading';
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';
export const GET_IS_MODAL_VISIBLE = 'isModalVisible';